import RestUtilities from './RestUtilities';
import AuthStore from '../stores/Auth';
import { UserRoles } from '../models/UserRoles'
import Users from '../models/Users'

interface IAuthResponse {
    token: string;
    role: string;
    registered: boolean
    personalNr: string;
    isLonhabzugberechtigt: boolean
}

export default class Auth {
    static isSignedIn(): boolean {
        // return true
        return !!AuthStore.getToken() && AuthStore.getRegistered() == 'true'
    }

    static isAdmin(): boolean {
        return AuthStore.getRole() === UserRoles[UserRoles.Administrator] ||
               AuthStore.getRole() === UserRoles[UserRoles.TeilAdministrator]
    }

    static isIsLonhabzugberechtigt(): string {
        return AuthStore.getIsLonhabzugberechtigt()
    }

    signInOrRegister(email: string, password: string, isRegister: boolean = false) {
        return RestUtilities.post<IAuthResponse>(`/api/auth/${isRegister ? 'register' : 'login'}`,
            `username=${email}&password=${password}${!isRegister ? '&grant_type=password' : ''}`)
            .then((response) => {
                if (!response.is_error) {
                    AuthStore.setToken(response.content.token);
                    AuthStore.setRole(response.content.role, response.content.registered)
                    AuthStore.setPersonalNr(response.content.personalNr)
                    AuthStore.setIsLonhabzugberechtigt(response.content.isLonhabzugberechtigt)

                    if(response.content.registered == false) {
                        window.location.replace('/register')
                    }

                }
                return response;
            });
    }

    signIn(email: string, password: string) {
        return this.signInOrRegister(email, password, false);
    }

    register(email: string, password: string) {
        return this.signInOrRegister(email, password, true);
    }

    confirm(token: string): Promise<boolean> {
        return RestUtilities.post('/api/auth/confirm', { token: token })
            .then((response) => {
                return true;
            }).catch((err) => {
                console.log(err);
                return false;
            });
    }

    static signOut(): void {
        AuthStore.removeToken();
        AuthStore.removeRole()
        AuthStore.removePersonalNr()
        AuthStore.removeIsLonhabzugberechtigt()
    }
}
